<template>
  <div id="page-header" class="primary-background" ref="pageHeader">
    <a href="/" class="logo text-info" ref="logo"></a>
    <div class="top-menu-container">
      <el-menu :default-active="activeIndex"
        :style="{width:topMenuWidth+'px'}"
        class="top-menu"
        mode="horizontal"
        :router="true"
        background-color="#014289"
        text-color="#fff"
        active-text-color="#fff"
        >

        <el-menu-item v-for="(item) in menuChannelList"
          :index="item.path"
          :key="item.alias">{{ item.name }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="top-search" ref="topSearch">
      <div class="el-icon-search" title="搜索站内内容" @click="searchFormShown = true"></div>
    </div>
    <el-dropdown trigger="click" v-if="dropChannelList.length > 0"
      @command="handleDropmenuCommand">
      <div class="dropmenu-btn">
        <div style="width:22px;height: 100%;">&nbsp;</div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in dropChannelList"
          :key="item.alias"
          :command="item.path">{{ item.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
    <el-drawer
      ref="searchDrawer"
      title=""
      :visible.sync="searchFormShown"
      direction="ttb"
      size="160px"
      :append-to-body="true"
      :modal="false">
      <div class="top-search-container">
        <!--
        <div class="top-search-box">
          <el-input
            class="top-search-input"
            placeholder="请输入搜索关键词"
            v-model="qs"
            v-focus
            clearable
            @keyup.enter.native="handleSearch"
              >
              <i slot="prefix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
          </el-input>
          <el-button class="search-btn" @click="handleSearch">搜索</el-button>
        </div>
        -->
        <div class="top-search-box">
          <el-input placeholder="请输入搜索关键词" v-model="qs" class="top-search-input"
            v-focus
            clearable
            @keyup.enter.native="handleSearch"
          >
            <el-select v-model="selectField" slot="prepend" placeholder="请选择">
              <el-option label="标题" value="1"></el-option>
              <el-option label="正文" value="2"></el-option>              
            </el-select>
            <!-- <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i> -->
          </el-input>
          <el-button class="search-btn" @click="handleSearch">搜索</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import * as channelConfig from "@/config/channels";

export default {
  props: {

  },
  data() {
    return {
      channelList:  [],
      menuChannelList: [],
      dropChannelList: [],
      activeIndex:'/',
      topMenuWidth: 200,
      searchFormShown: false,
      qs: null, 
      selectField: "1",     
    };
  },
  methods: {
    handleSearch(){
      if(this.qs == null || this.qs.length == 0 || this.qs == undefined){
        return;
      }
      this.$refs.searchDrawer.closeDrawer();
      this.$router.push(
          {
            path: '/search',
            query:{
              qs: encodeURIComponent(this.qs),
              f: this.selectField
            }
          }
      );
    },
    resizeTopMenu(){
      // menu可用宽度      
      //let screenW1 = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let screenW = document.documentElement.clientWidth;
      //let screenW = this.$refs.pageHeader.getBoundingClientRect().width;      
      let wLogo = this.$refs.logo.getBoundingClientRect().width;
      let wSearch = this.$refs.topSearch.getBoundingClientRect().width;      
      let wDrop = 0;
      let pagePadding = 40;
      let fontWidth = 20;
      let itemPadding = 40;
      if(screenW <= 700){
        wDrop = 24;
        pagePadding = 12;
        fontWidth = 18;
        itemPadding = 20;
      }      
      // 计算菜单宽度
      this.channelList.forEach((item, index)=>{
        item.width = itemPadding + item.name.length * fontWidth;
        item.index = index;
      }); 
      let wPadding = 2*pagePadding + 40;
      this.topMenuWidth = screenW - ( wLogo + wSearch + wDrop + wPadding);
      // 计算菜单中可以显示的菜单项
      let dropItems = [];
      let topItems = [];
      let itemsWidth = 0;
      let tmpWidth = 0;
      let currItem = this.channelList.find(item => item.path == this.activeIndex);
      if(currItem != null){
        tmpWidth = itemsWidth + currItem.width;
        if(tmpWidth < this.topMenuWidth){
          topItems.push(currItem);
          itemsWidth = tmpWidth;
          // 追加王选生平--优先展示该菜单
          if(currItem.path != '/shengping'){
            let temp = this.channelList.find(item => item.path == '/shengping');
            tmpWidth = itemsWidth + temp.width;
            if(tmpWidth < this.topMenuWidth){
              topItems.push(temp);
              itemsWidth = tmpWidth;              
            }
          }
        }
      }
      
      // 追加其他菜单项
      this.channelList.forEach((channel, index) =>{
        let tmpItem = topItems.find(item => item.path == channel.path);        
        if(tmpItem == null || tmpItem == undefined){
          tmpWidth = itemsWidth + channel.width;
          if(tmpWidth < this.topMenuWidth){
            // 项显示在top menu中
            topItems.push(channel);
            itemsWidth = tmpWidth;
          }else{
            // 显示在drop  menu中
            dropItems.push(channel);
          }
        }        
      });
      
      // 重新排序
      topItems.sort((item1, item2)=>{return item1.index - item2.index});
      dropItems.sort((item1, item2)=>{return item1.index - item2.index});

      this.menuChannelList = topItems;
      this.dropChannelList = dropItems;
    },

    handleDropmenuCommand(cmd){
      this.$router.push(
        {
          path: cmd,
        }
      );
    },

    initData(){
      
      this.channelList.push({
        name: '首页',
        alias: 'home',
        path: '/',
      });
      
      this.channelList.push(... channelConfig.channels);
      
      this.menuChannelList.push(... channelConfig.channels);      
      
    },


  },
  created() {
    this.initData();
    window.addEventListener('resize', this.resizeTopMenu);
  },
  destroyed(){
    window.removeEventListener('resize', this.resizeTopMenu);
  },
  mounted() {
    this.activeIndex = this.$route.path;
    if(this.activeIndex == null || this.activeIndex == '' || this.activeIndex == undefined){
      this.activeIndex = '/';
    }
    
    this.$nextTick(()=>{
      setTimeout(this.resizeTopMenu(), 200);        
    });
  },
  watch: {},
  directives:{
    focus:{
      inserted(el){
        if(el.querySelector('input')){
          el.querySelector('input').focus();
        }
      }
    }
  }
};
</script>

<style scoped>
#page-header {
  transition: all 0.3s;
  top: 0;
  width: 100%;
  height: 82px;
  z-index: 1003;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  padding-left: 40px;
  padding-right: 40px;
  position: fixed;
  top: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.logo{
  height: 66px;
  flex: 0 0 230px;
  background: url('~@/assets/icons/svg/logo.svg') no-repeat;
  background-size: cover;
}
.top-menu-container{
  flex-grow: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.top-menu{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  height: 82px;
  font-size: 20px;
  font-weight: bold;
  margin: 0 10px;
  overflow: hidden;
  justify-content: flex-end;
}

.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-menu--horizontal>.el-menu-item{
  height: 82px;
  line-height: 82px;
  font-size: 20px;
  border-bottom: none;
  padding: 0 20px;
}

.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: none;
  background: url('~@/assets/icons/svg/top-menu-line.svg') no-repeat;
  background-position: center 65px;
  color: #fff;
}

.dropmenu-btn{
  flex: 0 0 22px;
  height: 30px;
  background: url('~@/assets/icons/svg/menu.svg') no-repeat;
  background-position: center center;
  background-size: cover;
  
}
.dropmenu-btn:hover{
  opacity: 0.8;
}

/deep/.el-popper{
  margin-top: 5px;
}
/deep/.el-popper .popper__arrow{
  visibility: hidden;
}
/deep/ .el-select .el-input{
  width: 80px;
}

.top-search{
  color: #fff;
  font-size: 22px;
  text-align: right;
  flex: 0 0 28px;
  height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.top-search:hover{
  color: rgba(255, 255, 255, 0.8)
  }

  .top-search-container{
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .top-search-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px 30px 20px;
    max-width: 500px;
    width: 80%;
    gap: 5px;
  }
  .top-search-input{
    font-size: 16px;
    width: 100%;
  }

  .search-btn{

    opacity: 1;
    background: #014289;
    color: #fff;
    font-size: 16px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0em;
  }

  .search-btn:hover{
    opacity: 0.9;
  }

  /deep/.el-drawer__wrapper .el-drawer__header{
    margin-bottom: 0px;
  }

.pull-left {
  float: left !important;
}

@media screen and (max-width: 700px) {
  #page-header{
    height: 56px;
    padding: 8px 12px;
  }
  .logo{
    flex: 0 0 40px;
    height: 40px;    
    background: url('~@/assets/icons/svg/logo-wx.svg') no-repeat;
    background-size: cover;
  }
  .top-menu{
    height: 56px;
  }
  .el-menu--horizontal>.el-menu-item{
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    padding: 0 10px;
  }
  .el-menu--horizontal>.el-menu-item.is-active{  
  background-position: center 48px;  
}
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue